<template>
  <div>
    <div class="flex justify-center h-screen items-center" v-if="isLoading">
      <beat-loader :loading="true" :color="'#3152f6'"></beat-loader>
    </div>
    <div class="offer-page" v-show="offer">
      <section class="offer-section" v-if="offer">
        <div class="offer-slide felx-col lg:flex">
          <div
            class="flex lg:flex-col lg:w-1/2 justify-between items-start p-4 md:p-10 flex-wrap"
          >
            <div class="text-center lg:text-left order-1">
              <div class="font-bold font-blue">DATE</div>
              <div>{{ offer.attributes.createdAt.substring(0, 10) }}</div>
            </div>
            <div
              class="mt-24 lg:mt-0 text-center lg:text-left font-bold text-4xl md:text-8xl order-3 lg:order-2 w-full lg:w-auto"
            >
              Available <br />Offices
            </div>
            <div class="text-center lg:text-left order-2 lg:order-3">
              <div class="font-bold font-blue">AGENCY</div>
              <div>Offie</div>
            </div>
          </div>
          <div class="lg:w-1/2 flex items-center p-10 justify-center">
            <div>
              <img
                class="object-cover w-full max-h-full max-w-full rounded-xl"
                :src="imageUrl"
                alt=""
              />
            </div>
          </div>
        </div>
        <img class="ilogo absolute max-h-8" src="@/assets/ilogo.png" />
      </section>
      <section class="offer-section" v-if="offer">
        <div
          class="offer-slide flex flex-col lg:flex-row justify-center items-center overflow-scroll"
        >
          <div class="flex w-full lg:w-auto">
            <div
              class="flex w-full justify-center lg:justify-start items-center text-center lg:text-left font-bold text-4xl md:text-8xl p-10"
            >
              Executive <br />
              summary
            </div>
          </div>
          <div
            class="executive flex flex-col lg:flex-row text-left gap-4 lg:gap-6 pt-0 lg:pt-10 p-10"
          >
            <div
              v-for="sum in offer.attributes.summary"
              :key="sum.id"
              :class="`lg:w-1/${offer.attributes.summary.length}`"
            >
              <div
                class="flex lg:flex-col gap-2 lg:gap-0 font-bold lg:font-normal"
              >
                <!-- <div class="text-lg lg:text-8xl font-blue">0{{ ++i }}</div> -->
                <div class="font-bold text-lg">{{ sum.title }}</div>
              </div>
              <ul class="m-0 p-0 pl-4 text-lg">
                <li v-for="item in sum.item" :key="item.name">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <img class="ilogo absolute max-h-8" src="@/assets/ilogo.png" />
      </section>

      <section
        class="offer-section"
        v-for="(slide, i) in officeSlides"
        :key="i"
      >
        <div
          class="offer-slide block lg:flex items-center justify-center overflow-scroll"
        >
          <div
            class="flex flex-col flex-wrap lg:flex-row items-center justify-center gap-10 p-4 md:p-10"
          >
            <a
              v-for="office in slide"
              :key="office.id"
              class="no-underline office w-64 md:w-80 h-content rounded-xl"
              :href="
                `/irodak/${getSlug({
                  ...office.office.data.attributes,
                  id: office.office.data.id
                })}`
              "
              target="_blank"
            >
              <div class="h-full">
                <div class="rounded-xl bg-white text-left h-full">
                  <img
                    class="rounded-t-xl w-full aspect-video object-cover office-img"
                    :src="
                      getImageUrl(
                        office.office.data.attributes.mainImage.data.attributes
                          .url
                      )
                    "
                    alt=""
                  />
                  <div class="px-4 pb-4 pt-2 flex flex-col">
                    <div class="text-md md:text-lg font-bold mb-2">
                      {{ office.office.data.attributes.name }}
                    </div>
                    <div class="text-sm font-bold">
                      {{
                        `${office.office.data.attributes.postalCode} ${office.office.data.attributes.city}, ${office.office.data.attributes.addressLine}`
                      }}
                    </div>
                    <div class="my-4 text-xs md:text-base whitespace-pre-line">
                      {{ office.description }}
                    </div>
                    <div class="flex justify-between text-xs md:text-sm">
                      <div>Rent</div>
                      <div>
                        {{
                          `${office.office.data.attributes.priceFrom}${
                            office.office.data.attributes.priceFrom ===
                            office.office.data.attributes.priceTo
                              ? ""
                              : "-" + office.office.data.attributes.priceTo
                          }`
                        }}
                        EUR/m2/m
                      </div>
                    </div>
                    <div class="flex justify-between text-xs md:text-sm">
                      <div>Service Charge</div>
                      <div>
                        {{ office.office.data.attributes.serviceFee }} EUR/m2/m
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <img class="ilogo absolute max-h-8" src="@/assets/ilogo.png" />
      </section>

      <section class="offer-section">
        <div class="offer-slide flex items-center justify-center">
          <OfficeMap ref="map" :offices="offices" :zoom="12" :show="true" />
        </div>
      </section>
      <section class="offer-section">
        <div class="offer-slide flex items-center justify-center">
          <div>
            <img
              class="max-w-full max-h-40"
              src="@/assets/offie-logo-big.png"
              alt=""
            />
            <div class="text-lg md:text-2xl mb-6">
              Your Office Leasing Specialist
            </div>
            <div class="text-md md:text-lg">+36 30 474 14 72</div>
            <div class="text-md md:text-lg">info@offie.hu</div>
            <div class="text-md md:text-lg">
              Forward Advisory Ingatlantanácsadó Kft.
            </div>
            <div class="text-md md:text-lg">1013 Várkert rkp. 11, Budapest</div>
            <a href="https://offie.hu" class="text-md md:text-lg">offie.hu</a>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BeatLoader from "vue-spinner/src/PulseLoader.vue";
import OfficeMap from "@/components/offices/OfficeMap.vue";
import qs from "qs";
import { Loader } from "@googlemaps/js-api-loader";
import slugify from "slugify";

export default {
  name: "Offer",
  components: {
    BeatLoader,
    OfficeMap
  },
  data() {
    return {
      offer: null,
      isLoading: true,
      mapLoaded: false
    };
  },
  computed: {
    imageUrl() {
      return `${process.env.VUE_APP_API_URL}${this.offer.attributes.image?.data?.attributes?.url}`;
    },
    offices() {
      if (!this.offer) {
        return [];
      }
      return this.offer.attributes.offices
        .filter(o => {
          return o.office.data !== null;
        })
        .map(o => {
          const { _, office } = o;

          return {
            ...office.data.attributes,
            id: office.data.id,
            mainImage: {
              url: office.data.attributes.mainImage.data.attributes.url
            }
          };
        });
    },
    officeSlides() {
      if (!this.offer) {
        return [];
      }
      const offices = this.offer.attributes.offices.filter(o => {
        return o.office.data !== null;
      });
      return Array.from(Array(Math.ceil(offices.length / 3))).map((_, i) => {
        return offices.slice(i * 3, i * 3 + 3);
      });
    }
  },
  methods: {
    getImageUrl(url) {
      return `${process.env.VUE_APP_API_URL}${url}`;
    },
    getSlug(office) {
      return `${slugify(office.name, {
        replacement: "_",
        lower: true
      })}-${office.id}`;
    }
  },

  created() {
    const loader = new Loader({
      apiKey: process.env.VUE_APP_MAPS_API_KEY,
      version: "weekly",
      libraries: ["places"]
    });

    loader.load().then(googleInstance => {
      this.$refs.map.initGoogle(googleInstance);
    });
  },
  async mounted() {
    const query = {
      filters: { uid: { $eq: this.$route.params.id } },
      populate: "deep",
      pagination: {
        limit: 1,
        start: 0
      }
    };
    try {
      const offers = await axios.get(`offers?${qs.stringify(query)}`);
      this.offer = offers.data.data[0];
      if (!this.offer) {
        // this.$router.push("/not-found");
      }
      this.isLoading = false;
    } catch (e) {
      // console.log(e);
    }
  }
};
</script>

<style lang="scss">
.offer-page {
  background: $white;
  scroll-snap-type: y mandatory;
  overflow: scroll;
  overflow: scroll;
  min-height: 100vh;
  scroll-snap-points-y: repeat(100vh);
  scroll-snap-type: y mandatory;
  position: relative;

  .offer-section {
    height: 100vh;
    scroll-snap-align: start;
    text-align: center;
    position: relative;
    display: flex;
    padding: 0 !important;

    .ilogo {
      bottom: 40px;
      right: 40px;
    }

    .offer-slide {
      margin: 20px;
      background: $lightgray;
      width: 100%;
      // height: calc(100% - 40px);
      border-radius: 20px;

      .office-map {
        @media (max-width: 640px) {
          width: 90%;
          height: 90%;
        }
        width: 80%;
        height: 80%;
      }

      .office {
        &:hover {
          box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
          -webkit-box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
          -moz-box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
        }
      }

      .font-blue {
        color: $blue;
      }

      .office-img {
        aspect-ratio: 16 / 9;
      }

      .executive {
        max-height: 50vh;
      }
    }
  }
}
</style>
